(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  class BannerSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-slider-track]');
      this.slides = Array.from(el.querySelectorAll('[data-slide]'));
      this.prevBtn = el.querySelector('[data-slider-prev]');
      this.nextBtn = el.querySelector('[data-slider-next]');
      this.dots = Array.from(el.querySelectorAll('[data-slider-dot]'));
      this.counterCurrent = el.querySelector('[data-slider-current]');
      this.index = 0;
      this.autoplay = el.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 4000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.bindSwipe();
      if (this.autoplay) this.startAutoplay();
      this.update();
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.index - 1); this.resetAutoplay(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.index + 1); this.resetAutoplay(); });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.index, 10));
          this.resetAutoplay();
        });
      });
      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
    }

    bindSwipe() {
      let startX = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        if (Math.abs(diff) > 40) {
          this.go(diff > 0 ? this.index + 1 : this.index - 1);
          this.resetAutoplay();
        }
        isDragging = false;
      });
    }

    go(newIndex) {
      const max = this.slides.length - 1;
      this.index = newIndex < 0 ? max : newIndex > max ? 0 : newIndex;
      this.update();
    }

    update() {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      if (this.counterCurrent) this.counterCurrent.textContent = this.index + 1;
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    resetAutoplay() {
      if (this.autoplay) this.startAutoplay();
    }
  }

  document.querySelectorAll('[data-banner-slider]').forEach((el) => new BannerSlider(el));

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-banner-slider]');
    if (el) new BannerSlider(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
